// test1469
(1469 && 0);
